module.exports = __webpack_public_path__ + "img/shechipin.a53c8a93.png";